import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { IconButton, Icon, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ActivityBudgetForm from './ActivityBudgetForm'
import ActivityBudgetTableView from './ActivityBudgetTableView'
import {
  getActivity,
  saveActivity,
  updateActivity,
  deleteActivity,
  getProjectBudgetRefresh,
  getProjectBudget,
} from '../../../redux/actions/budget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ActivityBudgetWidgets(props) {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, setError } =
    useForm()
  const { showCommandButton, isEdit, onChangeIsEdit, onExpanded, valPanel } = props
  const { bordered, shaded, getSummary } = props
  // const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  // const [isEdit, setIsEdit] = useState(false)
  const [isEditDetail, setIsEditDetail] = useState(false)
  const [editDetailIndex, setEditDetailIndex] = useState(-1)
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [expanded, setExpanded] = useState(true)
  const [panelExpanded, setPanelExpanded] = useState(!isEdit)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // useEffect(() => {
  //   console.log('ooooo => ', formSchema)
  //   console.log('isEdit => ', isEdit)
  //   if (formSchema.value.length > 0) {
  //     setPanelExpanded(true)
  //   }
  // }, [panelExpanded])

  const handleUpdateSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateActivity(projectId, request)
      } else {
        console.log('call save.')
        response = await saveActivity(projectId, request)
      }
      console.log('response', response)

      if (response) {
        setFormSchema(response)
        setIsError(false)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (schama) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.', schama)
      const status = await deleteActivity(projectId, schama.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getActivity(projectId)
        console.log(('result', _schema))
        setFormSchema(_schema)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      id: data.selectedId,
      projectVersionId: projectId,
      actualPeriod: formSchema.actualPeriod,
      activity: data.activity,
      activityDetail: data.activityDetail,
      activityDurationExpectedStart: data.activityDurationExpectedStart,
      totalMonth: data.totalMonth || 0,
      activityDurationDate: data.activityDurationDate,
      activityDurationMonth: data.activityDurationMonth,
      underPurpose: [data.underPurpose],
      periodType: data.periodType,
    }

    handleUpdateSave(request)
  }

  const onDelete = (index) => {
    // console.log('onDelete', index)
    let dataList = [...formSchema.value]
    handleDelete(dataList[index])
  }

  const onBackToView = async () => {
    // const _schema = await getActivity(projectId)
    // setFormSchema(_schema)

    const _schema = await getProjectBudget(projectId)
    _schema?.forms?.managementFee[0]?.subForms.find((item) => {
      if (item.activity) {
        setFormSchema(item.activity)
      }
    })

    onChangeIsEdit(!isEdit)
    setIsError(false)
    setIsDeleteError(false)
    setIsEditDetail(false)
    onExpanded(true)
    setExpanded(true)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onEditDetail = (rowData) => {
    console.log('onEditDetail rowData', rowData)
    let schemaObj = formSchema
    // console.log('formSchema => ', formSchema)
    let data = schemaObj.value[rowData.index]
    // console.log('schemaObj', schemaObj)
    // console.log('data', data)
    schemaObj.activityDetail.value = data.activityDetail
    schemaObj.activity.value = data.activity
    schemaObj.activityDurationDate.value = data.activityDurationDate || []
    schemaObj.activityDurationMonth.value = data.activityDurationMonth || []
    schemaObj.activityDurationExpectedStart.value = data.activityDurationExpectedStart
    schemaObj.periodType.value = data.periodType
    schemaObj.totalMonth.value = data.totalMonth
    schemaObj.underPurpose.value = data.underPurpose[0] || data.underPurpose

    // console.log('onEditDetail schemaObj', schemaObj)
    setFormSchema(schemaObj)

    onChangeIsEdit(true)
    setIsEditDetail(true)
    onExpanded(false)
    setExpanded(false)
    setEditDetailIndex(rowData.index)
  }

  const onSetExpanded = (bool, rowData) => {
    let schemaObj = formSchema

    let data = schemaObj.value[rowData.index - 1]

    schemaObj.activityDetail.value = data.activityDetail
    schemaObj.activity.value = data.activity
    schemaObj.activityDurationDate.value = data.activityDurationDate || []
    schemaObj.activityDurationMonth.value = data.activityDurationMonth || []
    schemaObj.activityDurationExpectedStart.value = data.activityDurationExpectedStart
    schemaObj.periodType.value = data.periodType
    schemaObj.totalMonth.value = data.totalMonth
    schemaObj.underPurpose.value = data.underPurpose[0] || data.underPurpose

    setFormSchema(schemaObj)

    onExpanded(bool)
    onChangeIsEdit(true)
    setIsEditDetail(true)
    setEditDetailIndex(rowData.index - 1)
  }

  return (
    <Panel
      shaded={shaded}
      bordered={bordered}
      header={formSchema.header}
      // header={
      //   <div
      //     onClick={(e) => {
      //       setPanelExpanded(!panelExpanded)
      //     }}
      //   >
      //     {formSchema.header}
      //   </div>
      // }
      collapsible
      defaultExpanded={panelExpanded}
      ref={(section) => {
        setSection(section)
      }}
      // onClick={(e) => {
      //   if (e.target.className === 'rs-panel-heading' || e.target.className === 'collapsed') {
      //     setPanelExpanded(!panelExpanded)
      //   }
      // }}
      style={{ marginBottom: 20 }}
      // expanded={panelExpanded}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />
      {isEdit && showCommandButton ? (
        <ActivityBudgetForm
          key="ActivityBudgetForm"
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          setError={setError}
          clearErrors={clearErrors}
          getValues={getValues}
          onSubmit={handleSubmit(onSubmit)}
          onDelete={onDelete}
          showCommandButton={showCommandButton}
          isEditDetail={isEditDetail}
          editDetailIndex={editDetailIndex}
          // onEditActivityBudget={onEditActivityBudgetDetail}
          setExpanded={onSetExpanded}
          // onEditActivityBudget={xxxx}
          // onEdit={onEditDetail}
          isError={isError}
          isDeleteError={isDeleteError}
          loading={isLoading}
          onExpanded={expanded}
        />
      ) : (
        <>
          <ActivityBudgetTableView
            showCommandButton={showCommandButton}
            schema={formSchema}
            onEdit={onEditDetail}
          />
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          {isEdit ? (
            <div>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-info"
                icon={<Icon className="bt-gost-icon-radius-info" icon="backward" />}
                onClick={onBackToView}
              >
                กลับไปดูเงินสนับสนุนโครงการ
                {/* {`ดูรายการ${formSchema.buttonText || ''}`} */}
              </IconButton>
            </div>
          ) : (
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-edit"
              onClick={() => {
                // console.log(!isEdit)
                onChangeIsEdit(!isEdit)
                setIsEditDetail(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              icon={<Icon className="bt-gost-icon-radius-edit" icon="edit" />}
            >
              {/* {`แก้ไข${formSchema.header || ''}`} */}
              {`เพิ่ม/แก้ไข${formSchema.buttonText || ''}`}
            </IconButton>
          )}
        </>
      )}
    </Panel>
  )
}
